export default __webpack_public_path__ + "static/stremium-home1-01-7f35cd3958767fc257aa2bd2127da8b7.png";